const Conditional = (props: { check: boolean; alt?: JSX.Element; children: JSX.Element; path?: string }) => {
  const { check, children, alt } = props;
  if (check) {
    return children;
  }
  return alt || null;
};

export default Conditional;
